<template>
    <div>
        <div class="mb-2">
            <label class="form-label small">Campo documento</label>
            <select class="form-select form-select-sm" v-model="item.fieldName">
                <option value="">— Seleziona —</option>
                <option v-for="f in availableFields" :key="f" :value="f">{{ f }}</option>
            </select>
        </div>
        <div class="row mb-2">
            <div class="col-6">
                <label class="form-label small">Font Size</label>
                <input class="form-control form-control-sm" type="number" v-model.number="item.fontSize" />
            </div>
            <div class="col-6">
                <label class="form-label small">Colore</label>
                <input class="form-control form-control-sm" type="color" v-model="item.color" />
            </div>
        </div>
        <div class="mb-2">
            <label class="form-label small">Font Family</label>
            <select class="form-select form-select-sm" v-model="item.fontFamily">
                <option>Arial</option>
                <option>Times New Roman</option>
                <option>Courier New</option>
                <option>Verdana</option>
                <option>Georgia</option>
                <option>Helvetica</option>
            </select>
        </div>
        <div class="mb-2">
            <label class="form-label small">Font Weight</label>
            <select class="form-select form-select-sm" v-model="item.fontWeight">
                <option value="normal">Normal</option>
                <option value="bold">Bold</option>
                <option value="700">700</option>
            </select>
        </div>
        <div class="mb-2">
            <label class="form-label small">Allineamento</label>
            <select class="form-select form-select-sm" v-model="item.textAlign">
                <option value="left">Sinistra</option>
                <option value="center">Centro</option>
                <option value="right">Destra</option>
            </select>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';

@Options({})
export default class DocumentFieldConfigEditor extends Vue {
    @Prop() item: OM.DocumentFieldConfig;
    @Prop() documentType: string;
    @Prop() fields: string[];

    get availableFields(): string[] {
        return this.fields ?? [];
    }
}
</script>
